//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export enum InstagramPublishingStrategy {
  Automatic = 'automatic',
  Manual = 'manual',
}
